/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateAndMetrics/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentCount from './AppointmentCount/index'
import DayDate from './DayDate/index'
import DayTemplate from './DayTemplate/index'
import DotSeparator from './DotSeparator/index'
import ExamCount from './ExamCount/index'
import PatientCount from './PatientCount/index'
import React from 'react'
import StartCount from './StartCount/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DateAndMetrics({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DateAndMetrics"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="DateAndMetrics.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-3-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<DayDate
  viewPath={`${viewPath}/DayDate`}
/>
<div
  data-testid="DateAndMetrics.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-5-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<DayTemplate
  viewPath={`${viewPath}/DayTemplate`}
/>
</div>
<div
  data-testid="DateAndMetrics.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-5-Z2qrsUn': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<AppointmentCount
  viewPath={`${viewPath}/AppointmentCount`}
/>
<DotSeparator
  viewPath={`${viewPath}/DotSeparator`}
/>
<PatientCount
  viewPath={`${viewPath}/PatientCount`}
/>
</div>
<div
  data-testid="DateAndMetrics.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-5-Z2qrsUn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<ExamCount
  viewPath={`${viewPath}/ExamCount`}
/>
<DotSeparator
  viewPath={`${viewPath}/DotSeparator`}
/>
<StartCount
  viewPath={`${viewPath}/StartCount`}
/>
</div>
</div>
{children}
</React.Fragment>)
}